import { Box, useTheme } from "@mui/material";
import { useIsDashboardV2 } from "web_myplann/Dashboard/State/dashboardVariantContext";
import { getEvaluationChipColors } from "web_myplann/Dashboard/Utils/getEvaluationChipColors";
import { isEvaluationNearZero } from "web_myplann/Dashboard/Utils/isEvaluationNearZero";
import { PercentageDelta } from "web_myplann/Shared/Components/PercentageDelta";

type EvaluationChipProps = {
	evaluation: number;
};

export const EvaluationChip = ({ evaluation }: EvaluationChipProps) => {
	const { palette, shape } = useTheme();
	const isDashboardV2 = useIsDashboardV2();

	const isNearZero = isEvaluationNearZero(evaluation);
	const { bg, delta } = getEvaluationChipColors(
		palette,
		isDashboardV2,
		isNearZero,
		evaluation > 0,
	);

	return (
		<Box
			padding={isDashboardV2 ? "4px 12px" : "4px"}
			bgcolor={bg}
			borderRadius={shape.pillRadius}
			zIndex={1}
		>
			<PercentageDelta
				change={isNearZero ? 0 : evaluation}
				fontSize={12}
				fontWeight={500}
				lineHeight="16px"
				color={delta}
			/>
		</Box>
	);
};
